module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/sidebar/sidebar.component.css
// module id = ./src/app/common/sidebar/sidebar.component.css
// module chunks = main